const buildQueryString = (object) => {
    return  new URLSearchParams(
        Object.entries(object).filter(([key, value]) => value != null)
    ).toString();
}


export default {
    buildQueryString
}